import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/shadcn/dialog';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/shadcn/sheet';
import PadelScorePickerBody from './PadelScorePickerBody';

function useIsLgUp(): boolean {
  const [isLg, setIsLg] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const update = () => setIsLg(mq.matches);
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isLg;
}

interface PadelScorePickerSheetProps {
  open: boolean;
  onClose: () => void;
  teamLabel: string;
  value: number;
  targetScore?: number | null;
  americanoMode: boolean;
  onSelect: (score: number) => void;
}

export default function PadelScorePickerSheet({
  open,
  onClose,
  teamLabel,
  value,
  targetScore,
  americanoMode,
  onSelect,
}: PadelScorePickerSheetProps) {
  const isDesktop = useIsLgUp();

  const body = (
    <PadelScorePickerBody
      teamLabel={teamLabel}
      value={value}
      targetScore={targetScore}
      americanoMode={americanoMode}
      onSelect={onSelect}
      onClose={onClose}
    />
  );

  if (isDesktop) {
    return (
      <Dialog
        open={open}
        onOpenChange={(next) => {
          if (!next) onClose();
        }}
      >
        <DialogContent className="max-w-sm gap-0 p-6">
          <DialogHeader className="sr-only">
            <DialogTitle>Pilih skor {teamLabel}</DialogTitle>
          </DialogHeader>
          {body}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Sheet
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <SheetContent
        side="bottom"
        className="max-h-[90vh] overflow-y-auto rounded-t-2xl px-5 pb-8 pt-4"
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Pilih skor {teamLabel}</SheetTitle>
        </SheetHeader>
        {body}
      </SheetContent>
    </Sheet>
  );
}
